import { clubbiStyled, Spinner } from 'clubbi-ui'

const LANDING_COLORS = {
  purple: '#7C00F4',
  orange: '#FF4E1F',
  darkPurple: '#473195',
  yellow: '#FFC200',
  white: '#FFFFFF',
}

export const StyledPage = clubbiStyled('div')({
  width: '100%',
  minHeight: '100vh',
})

const CTA_BUTTON_STYLES = {
  width: '224px',
  height: '56px',
  borderRadius: '100px',
  padding: '0',
  gap: '8px',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontWeight: 700,
  fontSize: '16px',
  textDecoration: 'none',
  cursor: 'pointer',
  border: 'none',
  transition: 'opacity 0.2s',
  '&:hover': { opacity: 0.9 },
}

export const StyledSectionOne = clubbiStyled('section')(({ theme }) => ({
  background: LANDING_COLORS.purple,
  color: LANDING_COLORS.white,
  padding: '64px 40px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '24px',
  position: 'relative',
  overflow: 'hidden',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'stretch',
    justifyContent: 'flex-start',
    padding: '160px 0 16px 112px',
    minHeight: '400px',
  },
}))

export const StyledSectionOneYellowBand = clubbiStyled('div')(({ theme }) => ({
  position: 'absolute',
  width: '100vw',
  height: '1158px',
  top: '-561px',
  left: '711px',
  borderRadius: '120px',
  border: `76px solid ${LANDING_COLORS.yellow}`,
  background: 'transparent',
  pointerEvents: 'none',
  zIndex: 0,
  [theme.breakpoints.down('md')]: {
    width: '100vw',
    height: '75vw',
    minHeight: '400px',
    maxHeight: '550px',
    left: '20%',
    top: '-35%',
    borderWidth: '33px',
    borderRadius: '80px',
  },
}))

export const StyledSectionOneContent = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '20px',
  maxWidth: '560px',
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    order: 2,
  },
  [theme.breakpoints.up('md')]: {
    gap: '28px',
  },
}))

export const StyledSectionOneTitle = clubbiStyled('h1')(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: 1.2,
  color: LANDING_COLORS.white,
  [theme.breakpoints.up('md')]: {
    fontSize: '48px',
  },
}))

export const StyledSectionOneText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '16px',
  lineHeight: 1.5,
  color: LANDING_COLORS.white,
  opacity: 0.95,
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}))

export const StyledCtaButton = clubbiStyled('a')(({ theme }) => ({
  ...CTA_BUTTON_STYLES,
  [theme.breakpoints.down('sm')]: {
    width: '200px',
    height: '48px',
    fontSize: '14px',
  },
}))

export const StyledSectionOneCta = clubbiStyled(StyledCtaButton)({
  background: LANDING_COLORS.yellow,
  color: '#1a1a1a',
})

export const ButtonSpinner = clubbiStyled(Spinner)({
  width: '20px !important',
  height: '20px !important',
  color: '#1a1a1a !important',
})

export const StyledSectionOneImages = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginTop: '24px',
  width: '100%',
  position: 'relative',
  zIndex: 1,
  [theme.breakpoints.down('md')]: {
    order: 1,
  },
  [theme.breakpoints.up('md')]: {
    marginTop: 0,
    marginLeft: 'auto',
    flex: '0 0 auto',
    width: 'auto',
    minWidth: '55%',
    maxWidth: '65%',
    justifyContent: 'flex-end',
    alignItems: 'flex-end',
  },
}))

export const StyledSectionOneImg = clubbiStyled('img')(({ theme }) => ({
  maxWidth: '100%',
  height: 'auto',
  maxHeight: '280px',
  objectFit: 'contain',
  objectPosition: 'center center',
  [theme.breakpoints.up('md')]: {
    maxHeight: '520px',
    minHeight: '400px',
    width: 'auto',
    minWidth: '400px',
    maxWidth: 'none',
    objectPosition: 'right center',
  },
}))

export const StyledSectionTwo = clubbiStyled('div')(({ theme }) => ({
  background: LANDING_COLORS.orange,
  color: LANDING_COLORS.white,
  padding: '64px 40px',
  gap: '24px',
  [theme.breakpoints.up('md')]: {
    padding: '160px 100px',
    gap: '32px',
  },
}))

export const StyledSectionTwoHeader = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

export const StyledSectionTwoOrangeContent = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '16px',
  width: '100%',
  padding: '24px 0',
  [theme.breakpoints.up('md')]: {
    flex: '1 1 400px',
    maxWidth: '560px',
    alignItems: 'flex-start',
    order: 1,
  },
}))

export const StyledSectionTwoLogo = clubbiStyled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  order: -1,
  [theme.breakpoints.up('md')]: {
    order: 2,
    flex: '0 0 auto',
    minWidth: '332px',
    maxWidth: '400px',
    justifyContent: 'flex-end',
  },
  '& img': {
    minWidth: '200px',
    width: '100%',
    maxWidth: '280px',
    height: 'auto',
    objectFit: 'contain',
    [theme.breakpoints.up('md')]: {
      minWidth: '332px',
      minHeight: '308px',
      maxWidth: '380px',
    },
  },
}))

export const StyledSectionTwoTitle = clubbiStyled('h2')(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: '28px',
  lineHeight: 1.2,
  color: LANDING_COLORS.white,
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    fontSize: '32px',
    textAlign: 'left',
  },
}))

export const StyledSectionTwoText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '16px',
  lineHeight: 1.5,
  color: LANDING_COLORS.white,
  opacity: 0.95,
  textAlign: 'left',
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}))

export const StyledSectionTwoCarouselWrap = clubbiStyled('div')(({ theme }) => ({
  paddingBottom: '36px',
  margin: '0 -40px',
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    paddingBottom: '24px',
    paddingTop: '8px',
    margin: '0',
  },
}))

export const StyledSectionTwoCarouselCardsRow = clubbiStyled('div')(({ theme }) => ({
  display: 'none',
  [theme.breakpoints.up('md')]: {
    margin: '40px 0',
    display: 'flex',
    justifyContent: 'space-around',
    alignItems: 'center',
    gap: '24px',
    width: '100%',
    flexWrap: 'wrap',
  },
}))

export const StyledSectionTwoCarouselCard = clubbiStyled('div')<{ $isCenter?: boolean }>(
  ({ theme, $isCenter }) => ({
    background: LANDING_COLORS.white,
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 4px 20px rgba(0,0,0,0.08)',
    display: 'flex',
    flexDirection: 'column',
    padding: '20px',
    width: '310px',
    flexShrink: 0,
    minHeight: '370px',
    minWidth: '300px',
    [theme.breakpoints.up('md')]: {
      width: undefined,
      minWidth: $isCenter ? '393px' : undefined,
      maxWidth: $isCenter ? '400px' : '320px',
      minHeight: undefined,
      padding: $isCenter ? '24px' : '20px',
      height: $isCenter ? '400px' : '350px',
      flex: $isCenter ? '0 0 auto' : '0 1 auto',
    },
  })
)

export const StyledSectionTwoCarouselCardImageWrap = clubbiStyled('div')<{
  $isCenter?: boolean
}>(({ theme, $isCenter }) => ({
  width: '100%',
  minWidth: '263px',
  minHeight: '207px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  marginBottom: '16px',
  '& img': {
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    display: 'block',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: $isCenter ? '345px' : '280px',
    minHeight: $isCenter ? '271px' : '220px',
    marginBottom: $isCenter ? '20px' : '16px',
  },
}))

export const StyledSectionTwoCarouselCardTitle = clubbiStyled('h3')({
  margin: '0 0 8px',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: 1.25,
  color: LANDING_COLORS.orange,
})

export const StyledSectionTwoCarouselCardSubtitle = clubbiStyled('p')({
  margin: 0,
  fontSize: '14px',
  lineHeight: 1.45,
  color: LANDING_COLORS.orange,
})

export const StyledSectionTwoCtaWrap = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  width: '100%',
  margin: '40px 0',
  [theme.breakpoints.up('md')]: {
    flex: '1 1 100%',
    order: 4,
    justifyContent: 'left',
    margin: '24px 0',
  },
}))

export const StyledSectionTwoCta = clubbiStyled(StyledCtaButton)({
  background: LANDING_COLORS.white,
  color: LANDING_COLORS.orange,
})

export const StyledSectionTwoSlick = clubbiStyled('div')(({ theme }) => ({
  [theme.breakpoints.down('md')]: {
    '& .slick-list': {
      margin: '0 -12px',
      overflow: 'visible',
    },
    '& .slick-slide': { display: 'flex', justifyContent: 'center' },
    '& .slick-slide > div': {
      width: 'auto',
      padding: '0 12px',
      boxSizing: 'border-box',
    },
  },
  '& .slick-dots': {
    bottom: '-38px',
    '& li button:before': { fontSize: '10px', color: 'rgba(255,255,255,0.5)' },
    '& li.slick-active button:before': { color: LANDING_COLORS.white },
  },
}))

export const StyledSectionTwoPurple = clubbiStyled('div')(({ theme }) => ({
  background: LANDING_COLORS.darkPurple,
  color: LANDING_COLORS.white,
  borderRadius: '24px',
  padding: '32px 24px 24px',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateAreas: `
    "shop"
    "content"
    "premios"
    "disclaimer"
  `,
  gap: '24px',
  [theme.breakpoints.up('md')]: {
    borderRadius: '48px',
    padding: '40px 72px',
    gridTemplateColumns: 'minmax(0, 1fr) 220px',
    gridTemplateAreas: `
      "content right"
      "disclaimer right"
    `,
    alignItems: 'center',
    columnGap: '56px',
    rowGap: '12px',
  },
}))

export const StyledSectionTwoPurpleContent = clubbiStyled('div')(({ theme }) => ({
  gridArea: 'content',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '684px',
  },
}))

export const StyledSectionTwoPurpleTitle = clubbiStyled('h2')(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: 1.2,
  color: LANDING_COLORS.white,
  [theme.breakpoints.up('md')]: {
    fontSize: '36px',
  },
}))

export const StyledSectionTwoPurpleText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '16px',
  lineHeight: 1.5,
  color: LANDING_COLORS.white,
  opacity: 0.95,
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}))

export const StyledSectionTwoPurpleTextStrong = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontSize: '16px',
  lineHeight: 1.5,
  color: LANDING_COLORS.white,
  fontWeight: 700,
  [theme.breakpoints.up('md')]: {
    fontSize: '18px',
  },
}))

export const StyledSectionTwoPurpleShopTitle = clubbiStyled('h3')(({ theme }) => ({
  gridArea: 'shop',
  margin: 0,
  textAlign: 'right',
  fontWeight: 700,
  fontSize: '36px',
  lineHeight: 1,
  color: LANDING_COLORS.white,
  [theme.breakpoints.up('md')]: {
    fontSize: '40px',
    lineHeight: 1.1,
    textAlign: 'center',
  },
}))

export const StyledSectionTwoPurpleRight = clubbiStyled('div')(({ theme }) => ({
  display: 'contents',
  [theme.breakpoints.up('md')]: {
    gridArea: 'right',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    alignSelf: 'center',
    justifySelf: 'center',
    gap: '16px',
  },
}))

export const StyledSectionTwoPremios = clubbiStyled('div')(({ theme }) => ({
  gridArea: 'premios',
  background: 'rgba(255,255,255,0.25)',
  borderRadius: '32px',
  padding: '12px 20px',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '14px',

  width: '100%',
  height: '80px',
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    width: '192px',
    height: '261px',
    padding: '24px',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '24px',
  },
  '& img': {
    flexShrink: 0,
    maxWidth: '104px',
    width: '100%',
    height: 'auto',
    objectFit: 'contain',
    [theme.breakpoints.up('md')]: {
      maxWidth: '144px',
    },
  },
}))

export const StyledSectionTwoPremiosLabel = clubbiStyled('span')(({ theme }) => ({
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: 1.2,
  color: LANDING_COLORS.white,
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    fontSize: '28px',
    textAlign: 'center',
  },
}))

export const StyledSectionTwoDisclaimer = clubbiStyled('p')(({ theme }) => ({
  gridArea: 'disclaimer',
  margin: 0,
  fontSize: '12px',
  lineHeight: 1.4,
  color: 'rgba(255,255,255,0.8)',
  [theme.breakpoints.up('md')]: {
    fontSize: '14px',
  },
}))

export const StyledSectionThree = clubbiStyled('section')(({ theme }) => ({
  background: LANDING_COLORS.white,
  color: '#1E1E1E',
  padding: '64px 40px',
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  [theme.breakpoints.up('md')]: {
    padding: '96px 100px',
  },
}))

export const StyledSectionThreeTop = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '32px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: '48px',
  },
}))

export const StyledSectionThreeTextContent = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '640px',
    gap: '24px',
  },
}))

export const StyledSectionThreeTitle = clubbiStyled('h2')(({ theme }) => ({
  margin: 0,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: '40px',
  color: LANDING_COLORS.purple,
  [theme.breakpoints.up('md')]: {
    fontSize: '36px',
    lineHeight: '56px',
  },
}))

export const StyledSectionThreeDescription = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  color: '#1E1E1E',
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
    maxWidth: '620px',
  },
}))

export const StyledSectionThreeButtons = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
}))

export const StyledSectionThreeButton = clubbiStyled('div')(({ theme }) => ({
  width: '100%',
  minHeight: '46px',
  padding: '12px 16px',
  border: 'none',
  borderRadius: '100px',
  background: LANDING_COLORS.yellow,
  fontWeight: 500,
  fontSize: '18px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  textAlign: 'center',
  [theme.breakpoints.up('md')]: {
    width: '179px',
    height: '160px',
    borderRadius: '24px',
    padding: '24px 16px',
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
}))

export const StyledSectionThreeNotice = clubbiStyled('div')({
  width: '100%',
  background: '#F7EEFF',
  borderRadius: '16px',
  padding: '24px',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
})

export const StyledSectionThreeNoticeTitle = clubbiStyled('h3')(({ theme }) => ({
  margin: 0,
  color: '#1E1E1E',
  fontWeight: 700,
  fontSize: '18px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const StyledSectionThreeNoticeText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  color: '#1E1E1E',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const StyledSectionFour = clubbiStyled('section')(({ theme }) => ({
  background: '#F2F1F3',
  padding: '64px 40px',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gridTemplateAreas: `
    "content"
    "right"
    "support"
  `,
  gap: '32px',
  [theme.breakpoints.up('md')]: {
    padding: '96px 112px',
    gridTemplateColumns: 'minmax(0, 1fr) auto',
    gridTemplateAreas: `
      "content right"
      "support right"
    `,
    alignItems: 'center',
    justifyContent: 'space-between',
  },
}))

export const StyledSectionFourContent = clubbiStyled('div')(({ theme }) => ({
  gridArea: 'content',
  display: 'flex',
  flexDirection: 'column',
  gap: '20px',
  minWidth: '90%',
  boxSizing: 'border-box',
  [theme.breakpoints.up('md')]: {
    gap: '24px',
  },
}))

export const StyledSectionFourTitle = clubbiStyled('h2')(({ theme }) => ({
  margin: 0,
  color: LANDING_COLORS.orange,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: '40px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontSize: '36px',
    lineHeight: '56px',
  },
}))

export const StyledSectionFourText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  color: '#1E1E1E',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const StyledSectionFourSupport = clubbiStyled('div')(({ theme }) => ({
  gridArea: 'support',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '8px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    marginTop: '4px',
    alignSelf: 'end',
    alignItems: 'flex-start',
  },
}))

export const StyledSectionFourSupportText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  color: '#1E1E1E',
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const StyledSectionFourSupportPhone = clubbiStyled('a')(({ theme }) => ({
  display: 'inline-flex',
  alignItems: 'center',
  gap: '8px',
  color: '#1E1E1E',
  textDecoration: 'none',
  fontWeight: 700,
  fontSize: '20px',
  lineHeight: '28px',
  letterSpacing: '0.25px',
  width: 'fit-content',
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
}))

export const StyledSectionFourRight = clubbiStyled('div')(({ theme }) => ({
  gridArea: 'right',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  width: '100%',
  gap: '24px',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    justifyContent: 'space-between',
    gap: '20px',
  },
}))

export const StyledSectionFourAppImage = clubbiStyled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '540px',
  height: 'auto',
  objectFit: 'contain',
  [theme.breakpoints.up('md')]: {
    width: '501px',
    maxWidth: '501px',
  },
}))

export const StyledSectionFourStoreButtons = clubbiStyled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  gap: '16px',
  flexWrap: 'wrap',
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center',
    gap: '18px',
  },
}))

export const StyledSectionFourStoreButton = clubbiStyled('a')(({ theme }) => ({
  minWidth: '190px',
  height: '56px',
  borderRadius: '100px',
  border: 'none',
  background: LANDING_COLORS.orange,
  color: LANDING_COLORS.white,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '8px',
  fontWeight: 700,
  fontSize: '16px',
  lineHeight: '20px',
  letterSpacing: '0.1px',
  transition: 'opacity 0.2s',
  '&:hover': {
    opacity: 0.9,
  },
  '& .MuiSvgIcon-root': {
    fontSize: '20px',
  },
  [theme.breakpoints.up('md')]: {
    minWidth: '167px',
    height: '42px',
    fontSize: '18px',
    lineHeight: '20px',
    '& .MuiSvgIcon-root': {
      fontSize: '20px',
    },
  },
}))

export const StyledSectionFive = clubbiStyled('section')(({ theme }) => ({
  background: LANDING_COLORS.white,
  padding: '64px 40px',
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '32px',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '96px 112px',
    gap: '48px',
  },
}))

export const StyledSectionFiveContent = clubbiStyled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '24px',
  [theme.breakpoints.up('md')]: {
    maxWidth: '560px',
    alignItems: 'flex-start',
    textAlign: 'left',
    order: 1,
  },
}))

export const StyledSectionFiveImageWrap = clubbiStyled('div')(({ theme }) => ({
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.up('md')]: {
    width: 'auto',
    justifyContent: 'flex-end',
    order: 2,
  },
}))

export const StyledSectionFiveImage = clubbiStyled('img')(({ theme }) => ({
  width: '100%',
  maxWidth: '333px',
  height: 'auto',
  objectFit: 'contain',
  [theme.breakpoints.up('md')]: {
    maxWidth: '600px',
  },
}))

export const StyledSectionFiveTitle = clubbiStyled('h2')(({ theme }) => ({
  margin: 0,
  color: LANDING_COLORS.purple,
  fontWeight: 700,
  fontSize: '32px',
  lineHeight: '40px',
  letterSpacing: '0.25px',
  maxWidth: '300px',
  [theme.breakpoints.up('md')]: {
    fontSize: '36px',
    lineHeight: '56px',
    maxWidth: '100%',
  },
}))

export const StyledSectionFiveText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontWeight: 400,
  fontSize: '16px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const StyledSectionFiveCtaRow = clubbiStyled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '20px',
  width: '100%',
  [theme.breakpoints.up('md')]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    gap: '24px',
    maxWidth: '300px',
  },
}))

export const StyledSectionFiveCtaText = clubbiStyled('p')(({ theme }) => ({
  margin: 0,
  fontWeight: 500,
  fontSize: '14px',
  lineHeight: '22px',
  letterSpacing: '0.25px',
  [theme.breakpoints.up('md')]: {
    fontWeight: 600,
    fontSize: '20px',
    lineHeight: '28px',
  },
}))

export const StyledSectionFiveCta = clubbiStyled('a')(({ theme }) => ({
  width: '138px',
  height: '40px',
  borderRadius: '100px',
  background: LANDING_COLORS.purple,
  color: LANDING_COLORS.white,
  textDecoration: 'none',
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexShrink: 0,
  fontWeight: 700,
  fontSize: '14px',
  lineHeight: '20px',
  letterSpacing: '0.1px',
  textAlign: 'center',
  transition: 'opacity 0.2s',
  '&:hover': {
    opacity: 0.9,
  },
  [theme.breakpoints.up('md')]: {
    width: '224px',
    height: '56px',
    fontSize: '18px',
  },
}))
